import PasswordComplexityDepictor from "./PasswordComplexityDepictor";
export default PasswordComplexityDepictor